var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArrowHome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "12px",
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icArrowHome") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FOR-YOU_Options",
    transform: "translate(-125.000000, -3336.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22-Copy-9",
    transform: "translate(14.000000, 3069.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22-Copy-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.774214,267.180472 C121.55624,266.939843 121.193458,266.939843 120.967863,267.180472 C120.749889,267.412971 120.749889,267.799928 120.967863,268.031885 L125.056526,272.393009 L111.564497,272.393009 C111.249984,272.393551 111,272.660193 111,272.995664 C111,273.331135 111.249984,273.606449 111.564497,273.606449 L125.056526,273.606449 L120.967863,277.959444 C120.749889,278.200072 120.749889,278.587571 120.967863,278.819528 C121.193458,279.060157 121.556748,279.060157 121.774214,278.819528 L126.830803,273.425978 C127.056399,273.193478 127.056399,272.806522 126.830803,272.574564 L121.774214,267.180472 Z",
    id: "icArrowHome"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowHome);
export default __webpack_public_path__ + "static/media/icArrowHome.7d33d2cf3ceaf04475e502e7c1185ba7.svg";
export { ForwardRef as ReactComponent };